import { authenticatedApi } from './api';

export const API_CONVERSATION_PATH = '/handraising';

export const notifyHandRaised = (studio) => authenticatedApi.post(
	API_CONVERSATION_PATH,
	{ studio },
);
